// Kullanicinin yetkisine gore erisebildigi ILK sayfa.
// Dashboard yetkisi olmayan kullaniciyi /admin yerine erisebildigi ilk modüle
// yonlendirmek icin kullanilir (dashboard == /admin oldugu icin redirect loop'u onler).
const MODULE_ROUTES = [
  ['dashboard', '/admin', 0],
  ['qr_tarayici', '/tarayici', 0],
  ['uyeler', '/uyeler', 0],
  ['basvurular', '/basvurular', 0],
  ['aidatlar', '/aidatlar', 0],
  ['odemeler', '/odemeler', 0],
  ['giris_kayitlari', '/giris-kayitlari', 0],
  ['duyurular', '/duyurular', 0],
  ['raporlar', '/raporlar', 1], // requiredRole: yonetici
  ['website', '/website-yonetimi', 0],
  ['ayarlar', '/ayarlar', 0],
];
const ROLE_RANK = { gorevli: 0, yonetici: 1, baskan: 2 };

export function firstAllowedPath(user) {
  if (!user) return '/login';
  if (user.role === 'baskan') return '/admin';
  const perms = user.permissions || {};
  const rank = ROLE_RANK[user.role] || 0;
  for (const [key, path, minRank] of MODULE_ROUTES) {
    if (perms[key] && rank >= minRank) return path;
  }
  return '/profil';
}
